import { writable } from 'svelte/store';

export const PlansSizeStore = writable(0);
